import { Component, Inject, Input, forwardRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { MessagesService }          from '../messages/messages.service';
import { TillpaymentsService }      from './tillpayments.service';

@Component({
  selector   : 'wor-tillpayments-settings',
  template: require('./tillpayments.settings.component.html')
})
export class TillpaymentsSettingsComponent{
  @Input() settings : CompanyIntegrationsModel;

  constructor (
    @Inject(forwardRef(() => MessagesService)) private messagesService     : MessagesService,
    private router              : UIRouter,
    @Inject(forwardRef(() => TillpaymentsService)) private tillpaymentsService : TillpaymentsService,
    private translateService    : TranslateService
  ) {}

  activate () : void {
    this.tillpaymentsService.activatePos()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.TILLPAYMENTS.TILLPAYMENTS')
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  deactivate () : void {
    this.tillpaymentsService.deactivatePos()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.TILLPAYMENTS.TILLPAYMENTS')
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }
}
